import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import { useSelector, useDispatch } from 'react-redux';
import ArticlePage from "./pages/ArticlePage";
import LocalsPage from "./pages/LocalsPage";
import AboutPage from "./components/page/AboutPage";
import ContactPage from "./components/ContactPage";

import "./App.css";
import {
  Routes,
  Route,
  useLocation,
  Link
  } from "react-router-dom";

import CategoryPage from "./pages/CategoryPage";
import CategoryCartoonPage from "./pages/CategoryCartoonPage";
import TopInfoBar from "./components/TopInfoBar";

function useQuery() {
    return new URLSearchParams(useLocation().search);
    }

function App() {

    const { city, county, state, label } =
      useSelector(s => s.local?.location) || {};
    const display = city || county || state || label || 'California';
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    useEffect(() => {
      document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    }, [isMenuOpen]);
    
    return (
      <>
        <div className="app">
          <header className="header">
          <div className="top-bar">
            <div className="menu-button" onClick={()=>setIsMenuOpen(true)}>&#9776;</div>
            <div className="logo-container">
            <Link to="/"><img src="/logo3.png" alt="We Are Local. For Us, By Us News" className="logo" /></Link>
              <h1 className="site-tiitle" >We Are Local</h1> 
              <p className="site-subtiitle">
                For Us, By Us News: Essential News and Events to Keep Us Community Connected
              </p> 
            </div>
            <TopInfoBar />
          </div>
          <nav className="nav-menu">
            <Menu />
          </nav>
        </header>

      <Routes>
      <Route path="/" element={<LocalsPage />}/>
      <Route path="/category/:categoryId" element={<CategoryPage />} />
      <Route path="/categoryimage/:categoryId" element={<CategoryCartoonPage />} />
      <Route path="/category" element={<CategoryPage />} />
      <Route path="/article/:id" element={<ArticlePage />} />
      <Route path="/local" element={<LocalsPage />} />
      <Route path="/local/:label" element={<LocalsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      
      </Routes>
 {isMenuOpen && (
        <div className="mega-menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="mega-menu" onClick={(e) => setIsMenuOpen(false) }>
            <div className="menu-header">
              <h2>Sections</h2>
              <button onClick={() => setIsMenuOpen(false)} className="close-button">✖</button>
            </div>
            <div className="menu-columns">
              <Menu />
            </div>
          </div>  
        </div>
)}
      </div>
      <Footer/>
      </>
      );
      }
export default App;